import { render, staticRenderFns } from "./FxLeerMas.vue?vue&type=template&id=5a893aa9"
import script from "./FxLeerMas.vue?vue&type=script&lang=js"
export * from "./FxLeerMas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports